import { allowedFileFormats, uploadFileMaxSize } from '../../constants/globals';

import ButtonSave from '../Reusable/ButtonSave';
import ErrorHandler from '../Reusable/ErrorHandler';
import Modal from 'react-bootstrap/Modal';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { checkFileFormat } from '../../utils';
import withTranslations from '../../utils/HighOrderComponent';

class ModalForAddDecision extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadedFile: '',
      decisionType: null,

      errors: {},
    };
  }



  componentDidMount = () => {
    this.props.findAllDecisionTypes();
  };

  onFileChange = (e) => {
    this.setState({
      uploadedFile: e.target.files.length > 0 && e.target.files[0],
    });
  };

  handleClose = () => {
    this.props.handleClose();
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  changeComboAutocompleteValue = (name, newValue) => {
    this.setState({ [name]: { id: newValue } });
  };

  handleClientValidation = () => {
    let hasError = false;
    const { Errors } = this.props.t;
    let errors = {};

    if (!this.state.uploadedFile) {
      errors['uploadedFile'] = this.props.t.Errors.fileNotUploaded;
      hasError = true;
    }
    if (this.state.uploadedFile) {
      console.log('checkFileFormat([this.state.uploadedFile])',checkFileFormat([this.state.uploadedFile]))
      if (checkFileFormat([this.state.uploadedFile])) {
        errors['uploadedFile'] = Errors.invalidFormat;
        hasError = true;
      }
    }
    if (this.state.uploadedFile.size >= uploadFileMaxSize) {
      errors['uploadedFile'] = this.props.t.Errors.invalidFileSize;
      hasError = true;
    }

    this.setState({ errors });

    return hasError;
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (this.handleClientValidation()) {
      return;
    }

    const {
      handleAddDecisionWithAttachment,
      handleAdd,
      requestForSignetApprovalId,
    } = this.props || {};

    const newDecision = {
      ...this.props.decision,
      requestForSignetApproval: {
        id: requestForSignetApprovalId,
      },

      dateCreated: new Date(),
      decisionType: this.state.decisionType,
    };

    if (this.state.uploadedFile) {
      let formData = new FormData();

      formData.append('file', this.state.uploadedFile);
      formData.append('name', this.state.uploadedFile.name);
      formData.append(
        'decision',
        new Blob([JSON.stringify(newDecision)], {
          type: 'application/json',
        })
      );

      handleAddDecisionWithAttachment(formData);
    } else {
      handleAdd(newDecision);
    }
  };

  render() {
    const { error, deleteError, t } = this.props || {},
      { Labels, Tooltips } = t || {};

    let fileTitlePreview;
    if (this.state.uploadedFile) {
      fileTitlePreview = this.state.uploadedFile.name;
    } else {
      fileTitlePreview = Labels.fileTitlePreview;
    }

    
  console.log('state',this.state)

    return (
      <Modal
        show={this.props.show}
        onHide={this.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Body>
            <ErrorHandler
              error={error}
              deleteError={deleteError}
              showServerError={this.props.show}
            />
            <h5 className="title">{Labels.title}</h5>
            <form onSubmit={this.handleSubmit}>
              <div className="row">
                <div className="col-md-12" style={{ paddingTop: '2%' }}>
                  <div className="d-flex mt-4 mb-4 input-one-document">
                    <label
                      className="w-100 without-margin-bottom custom-file-upload"
                      style={{ cursor: 'pointer' }}
                    >
                      <input
                        type="file"
                        accept={allowedFileFormats}
                        style={{ display: 'none' }}
                        onChange={this.onFileChange}
                      />
                      <Tooltip
                        title={Tooltips.decisionAttachment}
                        placement="top"
                        arrow={true}
                      >
                        <i className="fas fa-paperclip fa-2x" />
                      </Tooltip>
                      {fileTitlePreview}
                      <i></i>
                    </label>
                    <hr className="lineBreaker-one-document " />
                  </div>
                  <div className="text-center">
                    {this.state.errors && (
                      <b>
                        <div style={{ color: 'red' }}>
                          {this.state.errors['uploadedFile']}
                        </div>
                      </b>
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                <ButtonSave onClick={this.handleSubmit} />
              </div>
            </form>
          </Modal.Body>
        </Modal.Header>
      </Modal>
    );
  }
}

export default withTranslations(ModalForAddDecision, 'ModalForAddDecision');
